import {useCookies} from "react-cookie";
import {useEffect, useState} from "react";
import {DateTime} from "luxon";
import {HOME_URL} from "../lib/const.ts";
import ReactGA from "react-ga4";
import {BIT_SHIFT, GroupsType,} from "../types/step.ts";
import {DynamicTemplateLoader} from "@/components/ui/DynamicTemplateLoader.tsx";
import {QuizResult} from "@/types/quiz-types.ts";
import {useTemplate} from "@/contexts/templateContext.tsx";
import {getTemplateGroups} from "@/utils/get-template-groups.ts";
import {getTemplateResults} from "@/utils/get-template-results.ts";

export const Result = () => {
    const [points, setPoints] = useState<Record<string, number>>({});
    const [cookies, setCookie] = useCookies([import.meta.env.VITE_COOKIE_NAME]);
    const [groups, setGroups] = useState<GroupsType[]>();
    const [results, setResults] = useState<QuizResult[]>();
    const [groupsCounter, setGroupsCounter] = useState<Record<string, number>>({});
    const { template } = useTemplate();

    results?.forEach(quizRes => {
        if(!groupsCounter[quizRes.group]) {
            groupsCounter[quizRes.group] = 0;
        }
    });

    const highestCounter = Math.max(...Object.values(points));
    const highestKeys = Object.keys(points).filter(key => points[key] === highestCounter);
    const randomKey = highestKeys[Math.floor(Math.random() * highestKeys.length)];

    const result = results?.find(curr => curr.group === randomKey);

    useEffect(() => {
        const expiresAt = DateTime.now().plus({
            year: 1,
        });

        setCookie(import.meta.env.VITE_COOKIE_NAME, "1", {
            expires: expiresAt.toJSDate(),
            secure: true,
            path: '/',
        });

        setPoints(cookies['points'] as Record<string, number>);
    }, []);

    useEffect(() => {
        if( result ){
            ReactGA.send({
                hitType: 'pageview',
                page: '/result',
            })

            // ReactGA.event({
            //     category: "quiz",
            //     action: "result",
            //     label: `Ukończony quiz: ${result.label}`,
            //     value: highestCounter,
            // });
        }
    }, []);

    useEffect(() => {
        getTemplateResults(template).then(setResults);
        getTemplateGroups(template).then((groups) => {
            setGroups(groups as GroupsType[]);
        });
    }, [template]);

    if (!results || !result) return <div className="text-center text-black text-2xl pt-10">Ładowanie danych...</div>;

    const handleRegister = () => {
        ReactGA.event({
            category: "quiz",
            action: "register_btn",
        });
        setTimeout(() => {
            window.location.href = HOME_URL;
        }, 1000);
    };

    return (
        <>
            {result && (
                <DynamicTemplateLoader screenType={"ResultScreen"} componentProps={{
                    result,
                    onRegister: handleRegister,
                }} />
            )}
        </>
    );
};
